<template>
  <div class="download-container">
    <el-button size="medium" @click="downLoad">下载图片</el-button>
    <!-- <el-button size="medium">下载到手机</el-button> -->
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
export default {
  props: {
    fileList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {

    }
  },
  methods: {
    downLoad () {
      if (!this.fileList.length) {
        this.$message({
          type: 'error',
          message: '请选择您要下载的图片！'
        })
        return;
      }
      if (this.$emit('down')) {
        this.$emit('down')
      }
      this.fileList.forEach(file => {
        if (!file.base64Url) {
          this.image2Base64(file)
            .then(fileBase64 => {
              this.downLoadFile(fileBase64)
            })
        } else {
          this.downLoadFile(file)
        }
      })
    },

    image2Base64 (imageFile) {
      var promise = new Promise((resolve, reject) => {
        var base64Url = "";
        const image = new Image();
        image.src = imageFile.url;

        if (imageFile.width && imageFile.height) {
          image.width = imageFile.width;
          image.height = imageFile.height;
        }

        image.onload = () => {
          base64Url = this.$getImageBase64(image);
          imageFile.base64Url = base64Url;

          return resolve(imageFile);
        }
      })
      return promise;
    },

    downLoadFile (file) {
      let aLink = document.createElement('a');
      let blob = this.$base64ToBlob(file.base64Url); //new Blob([content]);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = file.name;
      // aLink.href = URL.createObjectURL(blob);
      aLink.href = file.base64Url;
      aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));//兼容火狐
    },
  }
}
</script>

<style lang="scss" scoped>
.download-container {
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
  
  .el-button {
    background-color: #24415C;
    color: #fff;
    width: 120px;
  }
}
</style>


// WEBPACK FOOTER //
// src/vue/components/Download/index.vue